const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function getCached(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || Date.now() > parsed.expiresAt) {
      sessionStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
}

export function setCache(key, data, ttlMs = DEFAULT_TTL_MS) {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({ data, expiresAt: Date.now() + ttlMs })
    );
  } catch {
    // sessionStorage full or unavailable — ignore
  }
}

export function clearCache(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export async function fetchWithCache(key, fetcher, { forceRefresh = false, ttlMs = DEFAULT_TTL_MS, fallback = null } = {}) {
  if (!forceRefresh) {
    const cached = getCached(key);
    if (cached != null) return cached;
  }

  try {
    const data = await fetcher();
    setCache(key, data, ttlMs);
    return data;
  } catch (err) {
    const stale = getCached(key);
    if (stale != null) return stale;
    if (fallback != null) return fallback;
    throw err;
  }
}
